<script setup>
import GuidanceComponent from "../../layouts/components/Notice.vue";
import HeadlineComponent from "./Headline.vue";
import utilHelper from "../../app/utilHelper";
const {getMailBody} = utilHelper();
import {inject} from "vue";

const props = defineProps({
    title: String,
    message: String,
    selections: Array,
    image: {
        type: String,
        required: false,
        default: null
    },
    inputValues: Object,
    keyFirstSetOrder: {
        type: Object,
        required: false,
        default: () => ({})
    },
    sendMailAddress: String,
    code: String,
    showConfirm: {
        type: Boolean,
        required: false,
        default: true
    },
    previousIndex: Number
});


const CONTACT_MAIL_ADDRESS = inject('CONTACT_MAIL_ADDRESS');
const index = inject('index');
const PROJECT_NAME = inject('PROJECT_NAME');
const code = inject('code', '');
const SUBJECT = PROJECT_NAME + '【ログイン】';

function getUrlEncodeText(text) {
    return encodeURIComponent(text);
}

function getSelectionIndex(selection) {
    if (!isNaN(selection.index)) {
        return selection.index;
    }
    return selection.index.value;
}

</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component v-if="props.title" :title="props.title"/>
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto uk-flex-center">
                <Guidance-component v-if="showConfirm" class="uk-width-1-1" :message="getMailBody(false, inputValues, code, keyFirstSetOrder)" style="overflow-y: scroll;"/>
                <div v-if="image" class="uk-margin-top">
                    <img :src="image" alt="image" class="uk-width-1-1"/>
                </div>
                <Guidance-component class="uk-width-1-1" :message="message"/>
            </div>
            <div class="uk-margin uk-flex">
                <div class="uk-flex-1">
                    <router-link :to="'/form/' + previousIndex">
                        <button class="uk-button uk-button-default uk-border-rounded uk-margin-auto uk-width-auto">戻る</button>
                    </router-link>
                </div>
                <template v-if="selections.length > 0" v-for="selection in selections">
                    <div class="uk-flex-1">
                        <router-link :to="'/form/' + getSelectionIndex(selection)">
                            <button
                                class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                                @click="$emit('changeIndex')">{{ selection.text }}
                            </button>
                        </router-link>
                    </div>
                </template>
                <template v-else>
                    <div class="uk-flex-1">
                        <a :href="'mailto:' + CONTACT_MAIL_ADDRESS + '?subject=' + getUrlEncodeText(SUBJECT) + '&body=' + getUrlEncodeText(getMailBody(true, inputValues, code, keyFirstSetOrder))">
                            <button class="uk-button uk-button-primary uk-border-rounded uk-margin-auto uk-width-auto"
                                    @click="$emit('sendMail')">
                                メーラーを起動
                            </button>
                        </a>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped>
#guidance-wrapper {
    align-items: center;
}
</style>